import { render, staticRenderFns } from "./Dwzjgqtx.vue?vue&type=template&id=06d12328&scoped=true&"
import script from "./Dwzjgqtx.vue?vue&type=script&lang=js&"
export * from "./Dwzjgqtx.vue?vue&type=script&lang=js&"
import style0 from "./Dwzjgqtx.vue?vue&type=style&index=0&id=06d12328&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d12328",
  null
  
)

export default component.exports